const MarketPropertySelect = ({
    listingAlias = '',
    name = '',
    address = {},
    isMultifamily = false,
} = {}) => ({
    listingAlias: String(listingAlias),
    name: String(name),
    address: [address.street, address.city, address.state, address.zip].join(' '),
    isMultifamily: Boolean(isMultifamily),
});

const MarketPropertiesSelect = (
    properties = [],
) => ({
    properties: properties.map(MarketPropertySelect),
});

export default MarketPropertiesSelect;
